module.exports = __webpack_public_path__ + "static/media/default-profile-image.644adee0.svg";